import VendedorEnderecoService from "@/services/VendedorEnderecoService";

export const vendedorEndereco = {
  namespaced: true,
  state: {
    vendedorEndereco: {},
  },
  actions: {
    getVendedorEndereco({ commit }, payload) {
      return VendedorEnderecoService.GetVendedorEndereco(payload).then(
        (vendedorEndereco) => {
          return Promise.resolve(vendedorEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVendedorEndereco({ commit }, payload) {
      return VendedorEnderecoService.PostVendedorEndereco(payload).then(
        (vendedorEndereco) => {
          return Promise.resolve(vendedorEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVendedorEndereco({ commit }, payload) {
      return VendedorEnderecoService.PutVendedorEndereco(payload).then(
        (vendedorEndereco) => {
          return Promise.resolve(vendedorEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVendedorEndereco({ commit }, payload) {
      return VendedorEnderecoService.DeleteVendedorEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendedorEnderecoOData({ commit }, payload) {
      return VendedorEnderecoService.GetVendedorEnderecoOData(payload).then(
        (vendedorEndereco) => {
          return Promise.resolve(vendedorEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default vendedorEndereco;
